import { readWhenDownloaded } from 'serviceWorker/channelServers/entitySource';
import { withoutRefreshAfterRead } from 'serviceWorker/services/factories/createThrottledReadStorage';
import type {
  DocumentationModuleReads,
  DocumentationModuleStorages,
} from './types';

/**
 * The reads of the documentation module over its storages: each waits for the
 * first download of what it reads and refreshes it from the API afterwards, so
 * files and directories of others show without logging in again (PT-7139 dropped
 * the sync on project load).
 */
export function createDocumentationModuleReads({
  documentations,
  directories,
}: DocumentationModuleStorages): DocumentationModuleReads {
  const documentationsWithoutRefresh =
    withoutRefreshAfterRead(documentations);

  const readDocumentations: DocumentationModuleReads['documentations'] = (
    read,
    { refresh = true } = {}
  ) =>
    readWhenDownloaded(
      refresh ? documentations : documentationsWithoutRefresh,
      read
    );
  const readDirectories: DocumentationModuleReads['directories'] = (
    read
  ) => readWhenDownloaded(directories, read);

  return {
    documentations: readDocumentations,
    directories: readDirectories,
    directoryContent: (read) => readDocumentations(() => readDirectories(read)),
  };
}
